import { IUpcomingDatas } from './';

export const completed: IUpcomingDatas[] = [
  {
    status: 'completed',
    progress: 100,
    imageURL: '',
    en: {
      title: `List SWEAT
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $SWEAT 📈✨

・SWEAT / USDT

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
    tr: {
      title: `List SWEAT
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $SWEAT 📈✨

・SWEAT / USDT

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
    zh: {
      title: `List SWEAT
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $SWEAT 📈✨

・SWEAT / USDT

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
  },

  {
    status: 'completed',
    progress: 100,
    imageURL: '',
    en: {
      title: `List NEAR
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $NEAR 📈✨

・NEAR / USDT
・NEAR / BTC

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
    tr: {
      title: `List NEAR
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $NEAR 📈✨

・NEAR / USDT
・NEAR / BTC

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
    zh: {
      title: `List NEAR
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $NEAR 📈✨

・NEAR / USDT
・NEAR / BTC

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
  },
  {
    status: 'completed',
    progress: 100,
    imageURL: '',
    en: {
      title: `List ETHW & ETHS Trading`,
      content: `#Ultorex will list $ETHW and $ETHS📈✨ 
      
・ETHW / USDT
・ETHS / USDT
      
Trading is enabled.`,
      learnMoreUrl: '#',
    },
    tr: {
      title: `List ETHW & ETHS Trading`,
      content: `#Ultorex will list $ETHW and $ETHS📈✨ 
      
・ETHW / USDT
・ETHS / USDT
      
Trading is enabled.`,
      learnMoreUrl: '#',
    },
    zh: {
      title: `List ETHW & ETHS Trading`,
      content: `#Ultorex will list $ETHW and $ETHS📈✨ 
      
・ETHW / USDT
・ETHS / USDT
      
Trading is enabled.`,
      learnMoreUrl: '#',
    },
  },
  {
    status: 'completed',
    progress: 100,
    imageURL: '',
    en: {
      title: 'Launch of Mobile App for iOS and Android!',
      content: ``,
      learnMoreUrl: '#',
    },
    tr: {
      title: 'Launch of Mobile App for iOS and Android!',
      content: ``,
      learnMoreUrl: '#',
    },
    zh: {
      title: 'Launch of Mobile App for iOS and Android!',
      content: ``,
      learnMoreUrl: '#',
    },
  },
  {
    status: 'completed',
    progress: 100,
    imageURL: '',
    en: {
      title: `Add IOTX Staking/ Earn`,
      content: `Staking and ULT Earn activated.`,
      learnMoreUrl: '#',
    },
    tr: {
      title: `Add IOTX Staking/ Earn`,
      content: `Staking and ULT Earn activated.`,
      learnMoreUrl: '#',
    },
    zh: {
      title: `Add IOTX Staking/ Earn`,
      content: `Staking and ULT Earn activated.`,
      learnMoreUrl: '#',
    },
  },
  {
    status: 'completed',
    progress: 100,
    imageURL: '',
    en: {
      title: `Support of X-Chain on Avalanche (AVAX). Ultorex previously only support C-Chain deposits.`,
      content: ``,
      learnMoreUrl: '#',
    },
    tr: {
      title: `Support of X-Chain on Avalanche (AVAX). Ultorex previously only support C-Chain deposits.`,
      content: ``,
      learnMoreUrl: '#',
    },
    zh: {
      title: `Support of X-Chain on Avalanche (AVAX). Ultorex previously only support C-Chain deposits.`,
      content: ``,
      learnMoreUrl: '#',
    },
  },
  {
    status: 'completed',
    progress: 100,
    imageURL: '',
    en: {
      title: `List LUNA
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $LUNA📈✨

・LUNA / USDT
・LUNA / BTC

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
    tr: {
      title: `List LUNA
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $LUNA📈✨

・LUNA / USDT
・LUNA / BTC

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
    zh: {
      title: `List LUNA
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $LUNA📈✨

・LUNA / USDT
・LUNA / BTC

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
  },
  {
    status: 'completed',
    progress: 100,
    imageURL: '',
    en: {
      title: `List LUNC
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $LUNC📈✨

・LUNC / USDT
・LUNC / BTC

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
    tr: {
      title: `List LUNC
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $LUNC📈✨

・LUNC / USDT
・LUNC / BTC

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
    zh: {
      title: `List LUNC
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $LUNC📈✨

・LUNC / USDT
・LUNC / BTC

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
  },

  {
    status: 'completed',
    progress: 100,
    imageURL: '',
    en: {
      title: `List IOTX 
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $IOTX📈✨

・IOTX / USDT
・IOTX / USD

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
    tr: {
      title: `List IOTX
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $IOTX📈✨

・IOTX / USDT
・IOTX / USD

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
    zh: {
      title: `List IOTX
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $IOTX📈✨

・IOTX / USDT
・IOTX / USD

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
  },
  {
    status: 'completed',
    progress: 100,
    imageURL: '',
    en: {
      title: `Support deposits and withdrawals of USDT on the Solana blockchain.`,
      content: `#Ultorex now supports deposits/withdrawals of $USDT on #Solana✨`,
      learnMoreUrl: '#',
    },
    tr: {
      title: `Support deposits and withdrawals of USDT on the Solana blockchain.`,
      content: `#Ultorex now supports deposits/withdrawals of $USDT on #Solana✨`,
      learnMoreUrl: '#',
    },
    zh: {
      title: `Support deposits and withdrawals of USDT on the Solana blockchain.`,
      content: `#Ultorex now supports deposits/withdrawals of $USDT on #Solana✨`,
      learnMoreUrl: '#',
    },
  },
  {
    status: 'completed',
    progress: 100,
    imageURL: '',
    en: {
      title: `List DOT
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $DOT📈✨

・DOT / USDT
・DOT / BTC

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
    tr: {
      title: `List DOT
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $DOT📈✨

・DOT / USDT 
・DOT / BTC

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
    zh: {
      title: `List DOT
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $DOT📈✨

・DOT / USDT 
・DOT / BTC

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
  },
  {
    status: 'completed',
    progress: 100,
    imageURL: '',
    en: {
      title: `Orbs Staking Auto-compound`,
      content: `The auto-compounding feature is available. 

Orbs staking rewards will be automatically re-staked once every week.`,
      learnMoreUrl: '#',
    },
    tr: {
      title: `Orbs Staking Auto-compound`,
      content: `The auto-compounding feature is available. 

Orbs staking rewards will be automatically re-staked once every week.`,
      learnMoreUrl: '#',
    },
    zh: {
      title: `Orbs Staking Auto-compound`,
      content: `The auto-compounding feature is available. 
      
Orbs staking rewards will be automatically re-staked once every week.`,
      learnMoreUrl: '#',
    },
  },
  {
    status: 'completed',
    progress: 100,
    imageURL: '',
    en: {
      title: `Withdraw with Email Verification Code`,
      content: ``,
      learnMoreUrl: '#',
    },
    tr: {
      title: `Withdraw with Email Verification Code`,
      content: ``,
      learnMoreUrl: '#',
    },
    zh: {
      title: `Withdraw with Email Verification Code`,
      content: `The auto-compounding feature is available. 
      
Orbs staking rewards will be automatically re-staked once every week.`,
      learnMoreUrl: '#',
    },
  },
  {
    status: 'completed',
    progress: 100,
    imageURL: '',
    en: {
      title: `List FTM
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $FTM📈✨

・FTM / USDT
・FTM / BTC

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
    tr: {
      title: `List FTM
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $FTM📈✨

・FTM / USDT
・FTM / BTC

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
    zh: {
      title: `List FTM
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $FTM📈✨

・FTM / USDT
・FTM / BTC

Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
  },
  {
    status: 'completed',
    progress: 100,
    imageURL: '',
    en: {
      title: `List DOGE & SHIB
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $DOGE and $SHIB 🐾🐾

・DOGE / USDT ・DOGE / BTC
・SHIB / USDT   ・SHIB / BTC
      
Trading/deposits/withdrawals are enabled. #woof`,
      learnMoreUrl: '#',
    },
    tr: {
      title: `List DOGE & SHIB
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $DOGE and $SHIB 🐾🐾


・DOGE / USDT ・DOGE / BTC
・SHIB / USDT   ・SHIB / BTC
            
Trading/deposits/withdrawals are enabled. #woof`,
      learnMoreUrl: '#',
    },
    zh: {
      title: `List DOGE & SHIB
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $DOGE and $SHIB 🐾🐾

・DOGE / USDT ・DOGE / BTC
・SHIB / USDT   ・SHIB / BTC
            
Trading/deposits/withdrawals are enabled. #woof`,
      learnMoreUrl: '#',
    },
  },
  {
    status: 'completed',
    progress: 100,
    imageURL: '',
    en: {
      title: 'Add ATOM Staking/ Earn',
      content: `Staking and ULT Earn activated.`,
      learnMoreUrl: '#',
    },
    tr: {
      title: 'Add ATOM Staking/ Earn',
      content: `Staking and ULT Earn activated.`,
      learnMoreUrl: '#',
    },
    zh: {
      title: 'Add ATOM Staking/ Earn',
      content: `Staking and ULT Earn activated.`,
      learnMoreUrl: '#',
    },
  },
  {
    status: 'completed',
    progress: 100,
    imageURL: '',
    en: {
      title: `List ATOM
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $ATOM📈✨

・ATOM / USDT
・ATOM / BTC
      
Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
    tr: {
      title: `List ATOM
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $ATOM📈✨

・ATOM / USDT
・ATOM / BTC
      
Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
    zh: {
      title: `List ATOM
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $ATOM📈✨

・ATOM / USDT
・ATOM / BTC
      
Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
  },
  {
    status: 'completed',
    progress: 100,
    imageURL: '',
    en: {
      title: 'Orbs X Ultorex!! Orbs Staking Special Campaign',
      content: `#Ultorex will list $ORBS📈✨

Deposits/withdrawals are enabled.

Staking also activated.`,
      learnMoreUrl: '#',
    },
    tr: {
      title: 'Orbs X Ultorex!! Orbs Staking Special Campaign',
      content: `#Ultorex will list $ORBS📈✨

Deposits/withdrawals are enabled.

Staking also activated.`,
      learnMoreUrl: '#',
    },
    zh: {
      title: 'Orbs X Ultorex!! Orbs Staking Special Campaign',
      content: `#Ultorex will list $ORBS📈✨

Deposits/withdrawals are enabled.

Staking also activated.`,
      learnMoreUrl: '#',
    },
  },
  {
    status: 'completed',
    progress: 100,
    imageURL: '',
    en: {
      title: 'Support deposits and withdrawals of USDC on the Solana blockchain.',
      content: `#Ultorex now supports deposits/withdrawals of $USDC on #Solana✨\n
Trade your USDC with one of our pooled USD pairs!!`,
      learnMoreUrl: '#',
    },
    tr: {
      title: 'Support deposits and withdrawals of USDC on the Solana blockchain.',
      content: `#Ultorex now supports deposits/withdrawals of $USDC on #Solana✨\n
Trade your USDC with one of our pooled USD pairs!!`,
      learnMoreUrl: '#',
    },
    zh: {
      title: 'Support deposits and withdrawals of USDC on the Solana blockchain.',
      content: `#Ultorex now supports deposits/withdrawals of $USDC on #Solana✨\n
Trade your USDC with one of our pooled USD pairs!!`,
      learnMoreUrl: '#',
    },
  },
  {
    status: 'completed',
    progress: 100,
    imageURL: '',
    en: {
      title: 'Buy Crypto In Seconds',
      content: `Don’t bother with trading.

Buy the crypto you want in seconds!

Offered through our partner, @SimplexCC.

#Ultorex`,
      learnMoreUrl: '#',
    },
    tr: {
      title: 'Buy Crypto In Seconds',
      content: `Don’t bother with trading.

Buy the crypto you want in seconds!

Offered through our partner, @SimplexCC.

#Ultorex`,
      learnMoreUrl: '#',
    },
    zh: {
      title: 'Buy Crypto In Seconds',
      content: `Don’t bother with trading.

Buy the crypto you want in seconds!

Offered through our partner, @SimplexCC.

#Ultorex`,
      learnMoreUrl: '#',
    },
  },
  {
    status: 'completed',
    progress: 100,
    imageURL: '',
    en: {
      title: 'Support deposits and withdrawals of USDT on the Tron blockchain.',
      content: `#Ultorex now supports deposits/withdrawals of $USDT on  #Tron✨

Trade your USDT with one of our USDT pairs!!`,
      learnMoreUrl: '#',
    },
    tr: {
      title: 'Support deposits and withdrawals of USDT on the Tron blockchain.',
      content: `#Ultorex now supports deposits/withdrawals of $USDT on #Tron✨
      
Trade your USDT with one of our USDT pairs!!`,
      learnMoreUrl: '#',
    },
    zh: {
      title: 'Support deposits and withdrawals of USDT on the Tron blockchain.',
      content: `#Ultorex now supports deposits/withdrawals of $USDT on #Tron✨
      
Trade your USDT with one of our USDT pairs!!`,
      learnMoreUrl: '#',
    },
  },
  {
    status: 'completed',
    progress: 100,
    imageURL: '',
    en: {
      title: 'Support deposits and withdrawals of USDT on the Avalanche blockchain.',
      content: `#Ultorex now supports deposits/withdrawals of $USDT on #Avalanche✨\n
Trade your USDT with one of our USDT pairs!!`,
      learnMoreUrl: '#',
    },
    tr: {
      title: 'Support deposits and withdrawals of USDT on the Avalanche blockchain.',
      content: `#Ultorex now supports deposits/withdrawals of $USDT on #Avalanche✨\n
Trade your USDT with one of our USDT pairs!!`,
      learnMoreUrl: '#',
    },
    zh: {
      title: 'Support deposits and withdrawals of USDT on the Avalanche blockchain.',
      content: `#Ultorex now supports deposits/withdrawals of $USDT on #Avalanche✨\n
Trade your USDT with one of our USDT pairs!!`,
      learnMoreUrl: '#',
    },
  },
  {
    status: 'completed',
    progress: 100,
    imageURL: '',
    en: {
      title: `Create USDT and USD trading pairs
USD pairs available now for BTC & ETH`,
      content: `Ultorex will now pool USD stable coins to offer convenient trading of various cryptocurrencies.
  
Supported USD stable coins will trade under the “USD” symbol and include the following: USDC, BUSD, TUSD, DAI.      
USDT pairs will remain.`,
      learnMoreUrl: '#',
    },
    tr: {
      title: `Create USDT and USD trading pairs
USD pairs available now for BTC & ETH`,
      content: `Ultorex will now pool USD stable coins to offer convenient trading of various cryptocurrencies.
  
Supported USD stable coins will trade under the “USD” symbol and include the following: USDC, BUSD, TUSD, DAI.      
 USDT pairs will remain.`,
      learnMoreUrl: '#',
    },
    zh: {
      title: `Create USDT and USD trading pairs
      USD pairs available now for BTC & ETH`,
      content: `Ultorex will now pool USD stable coins to offer convenient trading of various cryptocurrencies.
  
Supported USD stable coins will trade under the “USD” symbol and include the following: USDC, BUSD, TUSD, DAI.      
USDT pairs will remain.`,
      learnMoreUrl: '#',
    },
  },
  {
    status: 'completed',
    progress: 100,
    imageURL: '',
    en: {
      title: `List MANA & SAND
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $MANA and $SAND📈✨ 

  ・MANA / USDT   ・MANA / BTC
  ・SAND / USDT    ・SAND / BTC

  Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
    tr: {
      title: `List MANA & SAND
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $MANA and $SAND📈✨

  ・MANA / USDT   ・MANA / BTC
  ・SAND / USDT    ・SAND / BTC

  Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
    zh: {
      title: `List MANA & SAND
Withdraw/ Deposit/ Trading`,
      content: `#Ultorex will list $MANA and $SAND📈✨

  ・MANA / USDT   ・MANA / BTC
  ・SAND / USDT    ・SAND / BTC

  Trading/deposits/withdrawals are enabled.`,
      learnMoreUrl: '#',
    },
  },
  {
    status: 'completed',
    progress: 100,
    imageURL: 'http://smiledoctor.com.sg/wp-content/uploads/2016/10/orionthemes-placeholder-image.jpg',
    en: {
      title: 'Add AVAX Withdraw/ Deposit/ Trading/ Staking/ Earn',
      content: `#Ultorex will list $AVAX📈✨\n
  ・AVAX / USDT
  ・AVAX / BTC\n
Trading/deposits/withdrawals are enabled.
Staking and ULT Earn also activated.`,
      learnMoreUrl: '#',
    },
    tr: {
      title: 'Add AVAX Withdraw/ Deposit/ Trading/ Staking/ Earn',
      content: `#Ultorex will list $AVAX📈✨\n
  ・AVAX / USDT
  ・AVAX / BTC\n
Trading/deposits/withdrawals are enabled.
Staking and ULT Earn also activated.`,
      learnMoreUrl: '#',
    },
    zh: {
      title: 'Add AVAX Withdraw/ Deposit/ Trading/ Staking/ Earn',
      content: `#Ultorex will list $AVAX📈✨\n
  ・AVAX / USDT
  ・AVAX / BTC\n
Trading/deposits/withdrawals are enabled.
Staking and ULT Earn also activated.`,
      learnMoreUrl: '#',
    },
  },
  {
    status: 'completed',
    progress: 100,
    imageURL: 'http://smiledoctor.com.sg/wp-content/uploads/2016/10/orionthemes-placeholder-image.jpg',
    en: {
      title: 'Add IOST Withdraw/ Deposit/ Staking/ Earn',
      content: `#Ultorex will list $IOST📈✨\n
Deposits/withdrawals are enabled.\n
Staking and ULT Earn also activated.`,
      learnMoreUrl: '#',
    },
    tr: {
      title: 'Add IOST Withdraw/ Deposit/ Staking/ Earn',
      content: `#Ultorex will list $IOST📈✨\n
Deposits/withdrawals are enabled.\n
Staking and ULT Earn also activated.`,
      learnMoreUrl: '#',
    },
    zh: {
      title: 'Add IOST Withdraw/ Deposit/ Staking/ Earn',
      content: `#Ultorex will list $IOST📈✨\n
Deposits/withdrawals are enabled.\n
Staking and ULT Earn also activated.`,
      learnMoreUrl: '#',
    },
  },
  {
    status: 'completed',
    progress: 100,
    imageURL: 'http://smiledoctor.com.sg/wp-content/uploads/2016/10/orionthemes-placeholder-image.jpg',
    en: {
      title: 'Ultorex Convert Function',
      content: `Convert function for all currencies.\n
Does not include conversions for IOST, XCR, XCRS & Rights token.`,
      learnMoreUrl: '#',
    },
    tr: {
      title: 'Ultorex Convert Function',
      content: `Convert function for all currencies.\n
Does not include conversions for IOST, XCR, XCRS & Rights token.`,
      learnMoreUrl: '#',
    },
    zh: {
      title: 'Ultorex Convert Function',
      content: `Convert function for all currencies.\n
Does not include conversions for IOST, XCR, XCRS & Rights token.`,
      learnMoreUrl: '#',
    },
  },
];
